export const data = [
 {
    requisite: "Краткое наименование:",
    text: "ООО Веха"
 },

 {
    requisite: "Генеральный директор:",
    text: "Леонтьева Ирина Федоровна"
 },

 {
    requisite: "ИНН:",
    text: "5038066419"
 },

 {
    requisite: "ОГРН:",
    text: "1085038015567"
 },

 {
    requisite: "КПП:",
    text: "503801001"
 },

 {
    requisite: "ОКПО:",
    text: "88871091"
 },

 {
    requisite: "ОКАТО:",
    text: "46247563000"
 },

 {
    requisite: "ОКВЭД:",
    text: "45.33"
 },

 {
    requisite: "Банк:",
    text: "ПАО Сбербанк г. Москва"
 },

 {
    requisite: "БИК:",
    text: "044525225"
 },

 {
    requisite: "Р/с:",
    text: "40702810940170004941"
 },

 {
    requisite: "К/с:",
    text: "30101810400000000225"
 }
]